import WhiteLogoComponent from "./whiteLogo";
import BlackLogoComponent from "./blackLogo";
import BrandMarkComponent from "./BrandMark";

export const WhiteLogo = WhiteLogoComponent
export const BlackLogo = BlackLogoComponent
export const BrandMark = BrandMarkComponent